import { createSelector } from 'reselect'
import {
    mediaBreakpoint__mobile,
    mediaBreakpoint__tabletLandscape,
    mediaBreakpoint__tabletPortrait,
} from '~/assets/styleConstants'
import { makeImageGroupStyle } from '~/utilities/imageGroupStyle'

import type { StateWithViewMode } from './reducer'

const getViewModeState = (state: StateWithViewMode) => state.viewMode

export const getViewportWidth = createSelector(
    getViewModeState,
    (viewModeState) => viewModeState.width,
)
export const getViewportHeight = createSelector(
    getViewModeState,
    (viewModeState) => viewModeState.height,
)

// If window width is less than breakpoint -> mobile, else desktop
export const isMobileMode = createSelector(
    getViewportWidth,
    (viewportWidth) => viewportWidth <= mediaBreakpoint__mobile,
)
export const isLargerThanTablet = createSelector(
    getViewportWidth,
    (viewportWidth) => viewportWidth > mediaBreakpoint__tabletLandscape,
)
export const isTabletPortraitOrSmaller = createSelector(
    getViewportWidth,
    (viewportWidth) => viewportWidth < mediaBreakpoint__tabletPortrait,
)

export const isLandscapeOrientation = createSelector(
    getViewportWidth,
    getViewportHeight,
    (viewportWidth, viewportHeight) => viewportWidth > viewportHeight,
)

export const getImageGroupStyle = createSelector(
    getViewportWidth,
    isMobileMode,
    makeImageGroupStyle,
)
